module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-down-left-e5ce543628b6f249fd29fe7aa4f71cbd.svg";